export let kvSlide = {
	current: 0,
	max: 3,
	start: 0,
	duration: 3000,
	target: null,
	init: function(){
		kvSlide.target = document.querySelector("#img_kv");
		if( kvSlide.target ){
			//console.log(kvSlide.target);
			kvSlide.start = kvSlide.getNow();
			kvSlide.timer = setInterval( function(){
				kvSlide.check();
			}, 200);
		}
	},
	inc: function(){
		kvSlide.current++;
		if(kvSlide.current >= kvSlide.max){
			kvSlide.current = 0;
		}
		kvSlide.move();
	},
	move: function(){
		let lists = kvSlide.target.querySelectorAll("li");
		kvSlide.target.className = "";
		kvSlide.target.classList.add("disable" + kvSlide.current);
		setTimeout(function(){
			let $ul = kvSlide.target.querySelector("ul");
			$ul.className = "";
			$ul.className = "current" + kvSlide.current;
			setTimeout(function(){
				kvSlide.target.className = "";
			}, 50);
		}, 500);
	},
	check: function(){
		let current = kvSlide.getNow();
		if( current - kvSlide.start >= kvSlide.duration ){
			kvSlide.start = kvSlide.getNow();
			kvSlide.inc();
		}
	},
	getNow: function(){
		let n = new Date();
		return n.getTime();
	}
}